import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Lenis from '@studio-freight/lenis';

const root = ReactDOM.createRoot(document.getElementById('root'));

const isCoarsePointer = window.matchMedia('(hover: none), (pointer: coarse)').matches;
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const shouldUseLenis = !isCoarsePointer && !prefersReducedMotion;

const fallbackLenis = {
  scrollTo: (target, options = {}) => {
    const behavior = options.immediate ? 'auto' : 'smooth';
    if (typeof target === 'number') {
      window.scrollTo({ top: target, behavior });
      return;
    }
    const node =
      typeof target === 'string'
        ? document.querySelector(target)
        : target;
    if (node?.scrollIntoView) {
      node.scrollIntoView({ behavior, block: 'start' });
    }
  },
  stop: () => {},
  start: () => {},
};

if (shouldUseLenis) {
  const lenis = new Lenis({
    duration: 0.95,
    easing: (t) => 1 - Math.pow(1 - t, 3),
    smoothWheel: true,
    wheelMultiplier: 0.9,
    smoothTouch: false,
  });
  window.lenis = lenis;

  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
} else {
  window.lenis = fallbackLenis;
}

root.render(
  <BrowserRouter>
    <Suspense fallback="...loading">
      <App />
    </Suspense>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
